import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RbacService } from '../rbac/rbac.service';
import { AuthService as CoreAuthService } from '../../core/auth/auth.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class PlatformAdminGuard implements CanActivate {
  constructor(
    private rbacService: RbacService,
    private coreAuth: CoreAuthService,
    private router: Router,
    private messageService: MessageService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const currentUser = this.coreAuth.getCurrentUser();

    if (!currentUser || !currentUser.userId || !currentUser.accessToken) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sesión Requerida',
        detail: 'Debes iniciar sesión para acceder a esta sección.',
        life: 4000,
      });
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    // Verificar permisos de administrador de plataforma
    const hasAdminAccess = await this.rbacService.checkPlatformAdminAccess(currentUser.userId, currentUser.accessToken);

    if (!hasAdminAccess) {
      this.messageService.add({
        severity: 'error',
        summary: 'Acceso Denegado',
        detail: 'No tienes permisos de administrador de plataforma para acceder a esta sección.',
        life: 5000,
      });
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
